// extracted by mini-css-extract-plugin
export default {"pages":"AdminUsers_pages__7c2Lf","polygon_admin":"AdminUsers_polygon_admin__ge-TK"};